import React from 'react';

interface PlaywireAdSlotProps {
    className?: string;
    id: string;
    index?: number;
}

const PlaywireAdSlot: React.FC<PlaywireAdSlotProps> = (props: PlaywireAdSlotProps) => {
    const { id, className, index } = props;

    const divIdWithSuffix = index && index > 1 ? `${id}${index}` : id;
    console.log(`[PlaywireAdSlot] rendering ad ${id}, index: ${index}, divId: ${divIdWithSuffix}`);

    return (
        <div className={className} id={divIdWithSuffix} />
    );
}

export default PlaywireAdSlot;
